<template>
    <div
        :class="['m_item','m_item'+id]">
        <div class="m_img">
            <img :src="secImg" alt="小秘书">
        </div>
        <i></i>
        <div class="m_content m_content_msg">

            <div class="m_content_msg_h1">
                <h1>{{ h1}}  </h1>
                <span class="switch" @click="switchQ()" v-if="questions_list && questions_list.length > 4">换一换</span>
            </div>

            <div class="m_content_msg_i" v-for="item in questions_list_f" :key="item.id"
                @click="sendQ('question',item.question,item.id,item.answer)"
            >
                <p>{{ item.question }}</p>
                <i></i>
            </div>
                                            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            changeQF:0,
            InterNum:4,
        }
    },
    props:{
        h1:String,
        id:String,
        questions_list:Array,
        secImg:String,
    },
    computed:{
        questions_list_f(){
            return this.questions_list.slice(this.changeQF,this.changeQF + this.InterNum);
        },
    },
    methods:{
        switchQ(){
            //改变问题
            if(this.changeQF + this.InterNum > this.questions_list.length){
                this.changeQF = 0;
            }
            else{
                this.changeQF = this.changeQF + this.InterNum;
            }
        },
        sendQ(type,content,qid,answer){
            this.$emit('sendQ',{
                type:type,
                content:content,
                qid:qid,
                answer:answer,
            })
        }
    }
}
</script>

<style lang="scss" scoped>

		.m_item{
			display: flex;
			margin-bottom: 22px;
			.m_img{
				width: 40px;
				height: 40px;
				border-radius: 50%;
				margin-right: 11px;
				// background: red;
				>img{
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			.m_content{
				width: 245px;
				background: #FFFFFF;
				border-radius:  6px;
				padding: 10px 15px;
				font-size: 15px;
				font-weight: 400;
				color: #333333;
				line-height: 22px;
				box-sizing: border-box;
				word-break: break-all;
			}
			i{
				width: 6px;
				height: 11.5px;
				margin-top: 8.5px;
				background: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/l_i.png") no-repeat;
				background-size: contain;
			}
			.m_content_msg{
				padding-bottom: 0;

				.m_content_msg_h1{
					display: flex;
					flex-direction: row;
					justify-content: space-between;
				}
				.switch{
					font-size: 11px;
					width:max-content;
					height: 20px;
					border-radius:  10px;
					border: 0.5px solid #E0E0E0;
					display: inline-block;
					background: url('https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/mes_r.png') no-repeat;
					background-size: 9.5px 8px;
					background-position: 4px 6px;
					color: #636363;
					padding-left: 16px;
					padding-right: 5px;
					display: flex;
					align-items: center;
                    white-space: nowrap;
				}

				h1{
					font-size: 12px;
					padding-bottom: 11px;
				}
				.m_content_msg_i{
					display: flex;
					justify-content: space-between;
					border-top: 1px solid #EBEBEB;
					font-size: 12px;

					>i{
						width: 8px;
						height: 13px;
						display: block;
						background: url('(https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/mes_i2.png') no-repeat;
						background-size: 100%;
						margin-right: 3.5px;
					}
					>p{
						
						padding: 5px 0 5px 11px;
						position: relative;
						width: 74%;
						&::before{
							content: "";
							display: none;
							position: absolute;
							width: 4px;
							height: 4px;
							background: #7D7D7D;
							border-radius: 50%;
							left: 5px;
							top: 20px;
						}
					}
				}

			}

		}
</style>